import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import TextEditor from "./TextEditor";
import { fetchMailMaster } from "./API";
import MoreInfoTextEditor from "./MoreInfoTextEditor";
import { Edit } from "@mui/icons-material";
import { Typography } from "@mui/material";

class MailMaster extends Component {
  state = {
    eventList: [{ vac_event: "Mail Event 1" }],
    Body: undefined,
    formData: {
      bint_srno: "",
      cmbEvent: "",
      txtSubject: "",
      txtBody: "",
    },
    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Mail Master");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveMailMaster,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtSubject,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    if (this.props.location.state && this.props.location.state.bint_srno) {
      const reqData = {
        Op: "ListMailMaster",
        bint_srno: this.props.location.state.bint_srno,
      };
      fetchMailMaster(reqData)
        .then((res) => {
          this.props.closeUpdateProcessing();
          const eventList = res.data.MailMasterList;
          let bint_srno = res.data.MailMasterList[0].bint_srno,
            cmbEvent = res.data.MailMasterList[0].vac_event,
            txtSubject = res.data.MailMasterList[0].vac_subject,
            Body = res.data.MailMasterList[0].vac_body;
          this.setState({
            eventList,
            formData: {
              ...this.state.formData,
              bint_srno,
              cmbEvent,
              txtSubject,
            },
            Body,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    } else {
      const reqData = {
        Op: "ListMailMaster",
      };
      fetchMailMaster(reqData)
        .then((res) => {
          this.props.closeUpdateProcessing();
          const eventList = res.data.MailMasterList;

          this.setState({
            eventList,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    }
    document.getElementById("cmbEvent").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          cmbEvent: "",
          txtSubject: "",
          txtBody: undefined,
        },
        Body: undefined,
      },
      () => {
        console.log("this.state.formData.txtBody", this.state.formData.txtBody);
        document.getElementById("cmbEvent").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationMailMaster = () => {
    let result = false;
    if (this.state.formData.cmbEvent.length <= 0) {
      this.props.toastErrorMsg("Select Event", "cmbEvent");
    } else if (this.state.formData.txtSubject.length <= 0) {
      this.props.toastErrorMsg("Enter Subject", "txtSubject");
    }
    // else if (this.state.formData.txtBody.length <= 0) {
    //   this.props.toastErrorMsg("Enter Body Text", "txtBody");
    // }
    else {
      result = true;
    }
    return result;
  };

  saveMailMaster = () => {
    this.trimFormData(() => {
      if (this.validationMailMaster()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveMailMaster",
          bint_srno: this.state.formData.bint_srno,
          vac_event: this.state.formData.cmbEvent,
          vac_subject: this.state.formData.txtSubject,
          vac_body: this.state.Body,
        };
        fetchMailMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              const eventList = res.data.MailMasterList || [];
              this.setState(
                {
                  eventList,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save Mail Master.", error);
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_subject) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_subject} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteMailMaster(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteMailMaster = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteMailMaster",
      bint_srno: bint_srno,
    };
    fetchMailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          const eventList = res.data.MailMasterList || [];
          this.setState(
            {
              eventList,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Mail Master. " + error,
        );
      });
    return false;
  };

  updateDetails = (id, Details) => {
    let Body = this.state.Body,
      withoutText = Details.replace(/<[^>]*>/g, "").trim();

    if (withoutText.length <= 0) {
      Details = withoutText;
    }

    if (id === "Body") {
      Body = Details;
    }

    this.setState(
      {
        Body,
      },
      () => {},
    );
  };
  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          // alertTitle={Heading}
          alertHeading={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };
  hasHtmlFormatting = (text) => {
    if (!text) return false;

    const div = document.createElement("div");
    div.innerHTML = text;

    const cleanedText = text.replace(/<p>\s*<\/p>/gi, "");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = cleanedText;

    const isVisiblyEmpty = tempDiv.textContent.trim() === "";
    const hasTags = /<[^>]+>/.test(cleanedText);

    const result = !isVisiblyEmpty && hasTags;

    return result;
  };
  handleBodyChange = (ctrlInfo) => {
    if (ctrlInfo && ctrlInfo.id === "txtBody") {
      this.setState({
        formData: { ...this.state.formData, txtBody: ctrlInfo.value },
      });
    }
  };
  resetEditorStateToUndefined = (id) => {
    if (id === "txtBody") {
      this.setState({
        formData: {
          ...this.state.formData,
          txtBody: undefined,
        },
      });
      // setTextTobeSet1(undefined);
    }
  };

  onEditorStateChange = (ctrlInfo) => {
    console.log("ctrlInfo", ctrlInfo);
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveMailMaster}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label={"Mail List"}
                  iconName={"List"}
                  className={"child-button"}
                  variant={"outlined"}
                  firstletterBig={false}
                  onClick={() => {
                    this.props.navigateTo("MailList");
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtSubject,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          spacing={2}
          marginTop={0}
          alignItems={"center"}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbEvent"
              label="Event*"
              items={this.state.eventList}
              value={this.state.formData.cmbEvent}
              handleOnChange={this.handleOnChange}
              width={260}
              maxLength={100}
              colID="vac_event"
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtSubject"}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtSubject"
              label="Subject*"
              value={this.state.formData.txtSubject}
              handleOnChange={this.handleOnChange}
              width={280}
              maxLength={200}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label={this.state.Body !== undefined ? "Edit Body" : "Add Body"}
              firstletterBig={false}
              iconName={this.state.Body !== undefined ? "Edit" : "New"}
              onClick={() => {
                this.openRichTextBox("Body", "Body", this.state.Body);
              }}
            />
          </Grid>
        </Grid>

        <Grid item>
          <div
            dangerouslySetInnerHTML={{
              __html: this.state.Body,
            }}
            style={{ margin: "0", padding: "0" }}
          />
        </Grid>
        {/* <Grid item marginTop={0} lg={8} md={8} sm={12} xs={12}>
          {!this.hasHtmlFormatting(this.state.formData.txtBody) ? (
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <div style={{ flex: 1 }}>
                <CtMultiLineText
                  id="txtBody"
                  label="Body"
                  value={this.state.formData.txtBody}
                  handleOnChange={this.handleOnChange}
                  width="100%"
                  maxLength={1000}
                  // onKeyDown={this.props.onKeyDown}
                />
              </div>
              <Edit
                className="child-button"
                style={{
                  marginTop: "26px", // aligns with the input field
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  color: "#1976d2",
                }}
                onClick={() => {
                  this.openRichTextBox(
                    "Body",
                    "Body",
                    this.state.formData.txtBody,
                  );
                }}
              />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "4px",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  Body
                </label>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.formData.txtBody,
                  }}
                  style={{
                    minHeight: "100px",
                    padding: "8px 12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "#f9f9f9",
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: "1.5",
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  }}
                />
              </div>
              <Edit
                className="child-button"
                style={{
                  marginTop: "26px", // aligns with the top of remark box
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  color: "#1976d2",
                }}
                onClick={() => {
                  this.openRichTextBox(
                    "Body",
                    "Body",
                    this.state.formData.txtBody,
                  );
                }}
              />
            </div>
          )}
        </Grid> */}
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <MailMaster {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
